module.exports = __webpack_public_path__ + "img/scenario_10.725a1383.jpg";